import React,{useEffect,useState} from 'react'
import styled from '@emotion/styled'
import { Link, useParams,withRouter } from 'react-router-dom';
import Konva from 'konva';
import { Stage, Layer, Circle } from 'react-konva';
import {getCustomerOrders, getCustomerProfile, getResourceFile, getTicketOrders} from '../../network';
import {connect} from 'react-redux';
import {formatCurrency, formatPrice} from '../../helpers/Helper';
import LoadingComponent from '../shared/LoadingComponent';

const { lerp } = require('canvas-sketch-util/math');
const random = require('canvas-sketch-util/random');

const SplashWrapper = styled.div`
    position:relative;
    width:inherit;
    height: 100vh;
    
    justify-content:center;
    p{
        position:relative;
        margin: 0 auto;
        padding-top: 13rem;
        justify-self:center;
        width: 31.625;
        color: var(--color-gray-600);
        font-family: Inter,sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: var(--font-14);
        line-height: var(--space-22);
    }
  
`;
const SplashScreen = styled.div`
    display:flex;
    flex-direction:column;
    height:100%;
    color:var(--color-white);
    text-align:center;
    img{
        margin-top:20rem;
    }
    h1{
        margin-top:10rem;
    }
`;
const SearchPage = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;

    img{
        margin-top:10rem;
        width:13.125rem;
        height:5rem;
        align-self:center
    }
    h1{
        text-align:center;
        margin-top:5rem;
    }
    span{
        color:var(--company-dark);
    }
   

`;
const SearchContainer = styled.div`
    display: flex;
    flex-direction: row;
    padding: var(--space-16) var(--sapce-20);
    margin-top:10rem;
    width: 39.5rem;
    height: 4.625rem;
    align-self:center;

    background: #FFFFFF;

    border: 1px solid #B8B8B8;
    box-sizing: border-box;

    box-shadow: inset 0px 2px 4px rgba(0, 0, 0, 0.06);
    border-radius: var(--space-8);

    input{
        padding: var(--space-12) var(--space-24);
        text-indent:1rem;
        height: var(--space-40);
        width:26rem;

        background: #F6F8F8;

        border: 1px dashed #D3D9DE;
        box-sizing: border-box;
        border-radius: var(--space-8);


    }
    button{
        padding: var(--space-12) var(--space-24);
        margin-left:2.69rem;
        height: var(--space-40);
        color:var(--color-white);
        background: #02B2D9;
        box-shadow: 0px 2px 6px rgba(2, 178, 217, 0.12), 0px 6px 15px rgba(4, 156, 189, 0.2);
        border-radius: 2.75rem;
    }
 
`;
const OrderScreen = styled.div`
    display:grid;
    grid-auto-flow:row;
    background-color:"red";
    width:inherit;
    height:100%;
    justify-content: center;
    .order-inline{

        margin-top:5rem;
        display:grid;
        grid-auto-flow:column;
        grid-gap:25rem;
        justify-self:center;
        align-items:flex-end;
        
    }
    .order-inline > h1{
        font-family: Inter,sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: var(--font-20);
        line-height: var(--space-24);
        color: var(--color-gray-700);
    }
    img{
        width: 8.75rem;
        height: var(--space-56);
        justify-self:center;
        margin-top:10%;
    }
    .copy{
        margin-top:1rem;
        margin-left:7.5%;
        width: 88%;
        height: var(--space-66);

        font-family: Inter,sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: var(--font-14);
        line-height: var(--space-22);

        color: #6E7B87
    }
`;
const Divider = styled.div`
    width: 44.125rem;
    height: 0rem;
    justify-self:center;
    margin-top:1rem;
    border: 1px solid #B3BDC6;
`;
const ImageContainer = styled.div`
    background-color:white;
    width: var(--space-64);
    height: var(--space-64);
    box-sizing: border-box;
    border-radius: 1px solid var(--color-gray-400);
    > img {
        width: 90%;
        height: 90%;
        object-fit: contain;
        padding: 0.25rem;
    }
`;
const OrderItemLayout = styled.div`
    margin-top:1rem;
    display:grid;
    grid-auto-flow:column;
    justify-content:center;
    grid-gap:3rem;

    h1{
        font-family: Inter,sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: var(--font-18);
        line-height: var(--space-20);
        
        display: flex;
       
        text-align: right;
        
        
        color: #3182CE;
    }

`;
const OrderItemName = styled.div`
    display:grid;
    grid-auto-flow:row;
    grid-gap:1rem;
`;
const Quantity = styled.div`
    display: flex;
    flex-direction: row;
    padding: var(--space-10) var(--space-12);

    width: var(--space-72);
    height: var(--space-40);


    background: #EDF0F2;

    border: 1px solid #8D9AA5;
    box-sizing: border-box;
    border-radius: 6px;
    p{
        display:none;
    }
`;
const OrderLayout = styled.div`
    margin-top:2rem;
    display:grid;
    grid-auto-flow:column;
    grid-gap:6rem;
    align-items: baseline;
    justify-content: space-evenly;
    .confirm{
        display: flex;
        flex-direction: row;
        padding: var(--space-10) var(--space-56);

        width: 13.94rem;
        height: var(--space-40);
        
        color:var(--color-white);
        background: #ED8936;
        box-shadow: 0px 4px 6px rgba(156, 66, 33, 0.12), 0px 2px 4px rgba(237, 137, 54, 0.32);
        border-radius: var(--space-6);
    }
    .subTotal{
        height: var(--space-18);
        
        
        font-family: Inter,sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: var(--font-18);
        line-height: var(--space-20);
        
        align-self:auto;
        
        color: #232323;
    }
    .total{
        height: var(--space-18);

        align-self:auto;
        font-family: Inter,sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: var(--font-18);
        line-height: var(--space-20);
        
        display: flex;
        align-items: center;
        text-align: right;

        
        color: #3182CE;
    }
`;
const ConfirmationPage = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;

    img{
        margin-top:10rem;
        width:100%;
        height:5rem;
        align-self:center
    }
    h1{
        text-align:center;
        align-self:center;
        margin-top:5rem;
        width: 26rem;
        height: var(--space-64);

        font-family: Inter,sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: var(--font-24);
        line-height: var(--space-32);

        color: #353B40;
    }
    .complete{
        font-family: Inter,sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: var(--font-20);
        line-height: var(--space-20);
        margin-top:1rem;
        display: flex;
        flex-direction: row;
        padding: var(--space-12) var(--space-48);
        align-self:center;
        height: 2.75rem;

        color:var(--color-white);
        background: #02B2D9;
        box-shadow: 0px 4px 6px rgba(2, 178, 217, 0.12), 0px 2px 4px rgba(2, 178, 217, 0.08);
        border-radius: 2.75rem;
    }

`;
let size = 0;
let total = 0;
const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJmaXJzdF9uYW1lIjoiSG93YXJkIiwibGFzdF9uYW1lIjoiRWR3YXJkcyIsImVtYWlsIjoiaG93YXJkLmVkd2FyZHNAc21zamEubmV0IiwidXNlcl9pZCI6IjVlNzE4MjFhZDc0NzM4NWRmOTkyMTZmMCIsInJvbGVfaWQiOiI1ZTczYzA4NzYxMTUyNDMyZjM4OGIwODkiLCJpYXQiOjE1OTI5NTMxMTAsImV4cCI6MTU5NTU0NTExMH0.iZVzm6NkayyuOMC__2oJwSEjkgXYG_ypbGqIBEBq5EE"
export const CashierView = () => {

    const [state,setState] = useState(false);
    const [searchText, setSearchText] = useState('');




    const enter = () => {
        setState(true);
    }
    return (
        <>
        {!state ?
        <SplashWrapper style={{backgroundColor:'var(--color-blue-400)'}} onClick={()=> enter()}>
            <SplashScreen>
                <img src="/img/white_logo.svg"/>
                <h1>Tap the screen to process an order</h1>
            </SplashScreen>
            {/* <Dots/> */}
        </SplashWrapper>
        :   <SplashWrapper>
                <SearchPage>
                    <img src="/irad-logo.svg"/>
                    <h1>Enter the <span>Order Confirmation Number</span> provided by the number</h1>
                    <SearchContainer>
                        <input type="search" placeholder="Enter Order Confimation number here" onChange={(e)=>setSearchText(e.target.value.trim())}/>
                        <Link to={{
                            pathname:"/kiosk/"+searchText,
                            state:{order:searchText}
                            }}><button>Proceed</button></Link>
                    </SearchContainer>
                    
                </SearchPage>
                <p>The Order Confirmation Number is provided in the email sent after placing an order online,
                         or in a Whatsapp chat after submitting a prescription.</p>
            </SplashWrapper>}
        </>
    )
}
export default CashierView



export const OrderLayer = () => {
    const [loading,setLoading] = useState(true);
    const [cartAmount,setCartAmount] = useState(total);
    let id = useParams();
    const [amount,setAmount] = useState(0);
    //const orders = location.state.order;
    const [order,setOrder] = useState([]);
    

    useEffect(() => search(id.id), []);

    const search = searchText => {
        getTicketOrders(token, searchText, 1, 3, '', '')
            .then(result => {
                setOrder([...result.data]);
                order.map((orders) =>{setAmount(orders.totalQuantity)});
                console.log(order);
            })
            .catch(error => console.error(error))
            .finally(setLoading(false));

            
    };
  
    const retrieveMedia = variant => {
        let src = null;
        if (variant.media && variant.media.length) {
            for (let i = 0; i < variant.media.length; i++) {
                if (variant.media[i].type === 'image') {
                    src = getResourceFile(variant.media[i].resource);
                    break;
                }
            }
        }

        if (!src) {
            if (variant.product_id.media && variant.product_id.media.length) {
                for (let i = 0; i < variant.product_id.media.length; i++) {
                    if (variant.product_id.media[i].type === 'image') {
                        src = getResourceFile(variant.product_id.media[i].resource);
                        break;
                    }
                }
            }
        }

        return src;
    };
    return(
        <>
        {loading ? 
            <LoadingComponent/>
        :    
    
        <SplashWrapper>
            <OrderScreen>
             
                <img src="/irad-logo.svg"/>
                <div className="order-inline">
                    <h1>{"Order "+id.id}</h1>
                    <Link to={"/cashier/cancel"}><h1 style={{color:"red"}}>Cancel Order</h1></Link>
                </div>
                <OrderLayout>
                    <Link to={"/cashier/done"}><button className="confirm">Confirm Order</button></Link>
                    <h1 className="subTotal">Subtotal ({amount === 0 ? amount+1 : amount} items)</h1>
                    <h1 className="total">{formatPrice(order.map((orders) =>{return orders.cartTotal}))}</h1>

                </OrderLayout>
                <span class="copy"> Please take a moment to review your order to make sure all is well.
                     If you have any issues with your order,
                      you may cancel and place a new order in-store, or speak to the Help Desk </span>
                <Divider/>
                {order.map((orders) =>
                <>
                {orders.variants.map((variant) =>{
                    const media = retrieveMedia(variant.variant);
                 return   <>
                <OrderItemLayout>
                    {console.log("Products: "+orders.totalQuantity)}
                    <ImageContainer>
                    {media && <img src={media}/>}
                    </ImageContainer>
                    <OrderItemName>
                    <span><b>{variant.variant.product.brand.name}</b>{` ${variant.variant.product.name}`}{`${variant.variant.description ? `, ${variant.variant.description}` : ''}`.trim()}</span>
                    <span>
                        {(variant.variant.product.attribute_name && variant.variant.attribute) && <>{variant.variant.attribute}</>}
                        {(variant.variant.product.attribute_name && variant.variant.attribute && variant.variant.product.size_name && variant.variant.size) && <>, </>}
                        {(variant.variant.product.size_name && variant.variant.size) && <>{variant.variant.size}</>}
                    </span>
                        
                        <Quantity>
                            <span>Qty:</span><span>{variant.quantity}</span>
                            <p>{total = variant.total}</p>
                            
                        </Quantity>
                    </OrderItemName>
                    <h1 style={{marginLeft:"9rem"}}>{formatPrice(variant.total)}</h1>
                   
                </OrderItemLayout>
                <Divider/>
                
                </>
                })}
                </>
                
                )}
                {order.length < 3 ?

                null
                :
                <OrderLayout style={{marginBottom:"2rem"}}>
                    <Link to={"/cashier/done"}><button className="confirm">Confirm Order</button></Link>
                    <h1 className="subTotal">Subtotal ({amount === 0 ? amount+1 : amount} items)</h1>
                    <h1 className="total">{formatPrice(order.map((orders) =>{return orders.cartTotal}))}</h1>
                </OrderLayout>
                }
                {/* <span class="copy"> Please take a moment to review your order to make sure all is well.
                     If you have any issues with your order,
                      you may cancel and place a new order in-store, or speak to the Help Desk </span> */}
            </OrderScreen>
        </SplashWrapper>
    }
        </>
    )
}

export const OrderDone = () => {
    let state = useParams();
    total = 0;
    return (
        <SplashWrapper>
            <ConfirmationPage>
            <img src="/irad-logo.svg"/>
                {state.id === "done" ?
                <h1>Your Order has been confirmed!
                Continue at the cashier</h1>
                :  <h1>Order cancelled. <br/>Thank you for choosing IRAD.</h1>
                    }
                <Link style={{alignSelf:"center"}}to={"/kiosk"}><button className="complete">Done</button></Link>
                
            </ConfirmationPage>
            {state.id === "done" ?
            <img style={{zIndex:"-1", position:"absolute", bottom: "0rem"}}src="/img/kiosk_image.jpg" alt="Order Complete Image"/>
            : null}
        </SplashWrapper>
    );
}

const Dots = () =>{
    const width = window.innerWidth;
    const height = 280;
    const margin = 45;
  
    let ignorePoints = [];
  
    const createGrid = () => {
      const points = [];
      const countX = 30;
      const countY = 4;
  
      for (let x = 0; x < countX; x++) {
        for (let y = 0; y < countY; y++) {
            const u = countX <= 1 ? 0.5 : x / (countX - 1);
            const v = countY <= 1 ? 0.5 : y / (countY - 1);
  
            points.push({
              colorSelect: "#D5D8D9",
              position: [u, v],
            });
  
          }
      }
      return points;
  }


  const points = createGrid();
  return(
    <Stage width={width} height={height} style={{position:"absolute",opacity:"0.55",top:"35rem"}}>
    <Layer>
      {points.map((data, index) => {
        const { position, colorSelect } = data;
        const [u, v] = position;
      
        return (
                <Circle
                    key={index}
                    x={lerp(margin, width - margin, u)}
                    y={lerp(margin, height - margin, v)}
                    radius={2.5}
                    fill={colorSelect}
                    shadowColor={colorSelect}
                    shadowBlur={4}
                    shadowOffsetY={2}
                    shadowOpacity={0.5}
                />
        );
    })}
    </Layer>
    </Stage>
  );
}